module.exports = __webpack_public_path__ + "static/media/bootcamp.f73c3edf.jpg";